import { useState, useCallback } from "react";
import { ResultsApi, Configuration } from "manager-common";
import { useAuth } from "react-oidc-context";

const MANAGER_API_BASE_URL = import.meta.env.VITE_MANAGER_API_BASE_URL;

export function useSubmitCompetition() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const auth = useAuth();

  const submitCompetition = useCallback(async (compYear, usefCompID) => {
    if (!compYear || !usefCompID || !auth.user?.access_token) {
      throw new Error("Missing required parameters");
    }

    setLoading(true);
    setError(null);

    try {
      const api = new ResultsApi(
        new Configuration({
          basePath: MANAGER_API_BASE_URL,
          accessToken: auth.user.access_token,
        })
      );

      const response = await api.submitCompetitionResults({
        compYear: parseInt(compYear, 10),
        usefCompID: parseInt(usefCompID, 10),
      });

      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.response?.data?.details ||
        err.message ||
        "Failed to submit competition";
      setError(errorMessage);
      throw new Error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, [auth.user?.access_token]);

  return { submitCompetition, loading, error };
}
